import { useWorkspaceStore } from '@/stores/workspace-store';

/**
 * Switch the active unit via a full page reload.
 * A reload re-runs the gate and refetches the tailored manifest and WebSocket
 * entitlements cleanly — no live plugin/layer teardown to get wrong.
 */
export function switchWorkspace(unitId: string): void {
  useWorkspaceStore.getState().setSelectedUnit(unitId);
  window.location.reload();
}
